<template>
    <div class="topheader" :class="isCORSite ? 'cor-header' : 'eesc-header'">
        <div class="app-title-wrapper d-flex align-items-center">
            <img class="me-2" src="../assets/images/star.svg" alt="Star shape with person inside" />
            <h5 class="app-title mb-0">
                {{ $t('system_name') }}
                <!-- {{ $t(isCORSite ? "lib_cor" : "lib_eesc") }} -->
            </h5>
        </div>
        <div class="d-flex align-items-center justify-content-end text-md">
            <div
                v-if="isAuthenticated"
                class="user-actions-dropdown dropdown d-none d-sm-inline-block"
            >
                {{ $t('lib_welcome') }},
                <a
                    class="dropdown-toggle"
                    href="#"
                    id="user-actions-dropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    :aria-label="userName"
                >
                    {{ userName }}
                </a>
                <ul
                    class="dropdown-menu"
                    aria-labelledby="user-actions-dropdown"
                >
                    <li>
                        <a
                            class="dropdown-item user-action logout-link"
                            :href="logoutLink"
                            @click="clearSession"
                            :aria-label="$t('btn_logout')"
                        >
                            {{ $t('btn_logout') }}
                        </a>
                    </li>
                </ul>
            </div>
            <!-- Site logo : START -->
            <a class="site-logo-link" :href="appLogoUrl" target="_blank" aria-label="Site logo">
                <img class="site-logo" :src="siteLogoImgSrc" alt="Site logo" />
                <span>
                    {{ $t(isCORSite ? 'lib_cor' : 'lib_eesc') }}
                </span>
            </a>
            <!-- Site logo : END -->
        </div>
    </div>
    <div class="midheader text-white text-end d-md-none">
        <!-- User dropdown : START -->
        <div
            v-if="isAuthenticated"
            class="user-actions-dropdown dropdown d-sm-none"
        >
            {{ $t('lib_welcome') }},
            <a
                class="dropdown-toggle"
                href="#"
                id="user-actions-dropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                :aria-label="userName"
            >
                {{ userName }}
            </a>
            <ul class="dropdown-menu" aria-labelledby="user-actions-dropdown">
                <li>
                    <a
                        class="dropdown-item user-action logout-link"
                        :href="logoutLink"
                        :aria-label="$t('btn_logout')"
                    >
                        {{ $t('btn_logout') }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div
        class="subheader shadow-sm align-items-end d-flex justify-content-between"
    >
        <Breadcrumbs></Breadcrumbs>
        <div class="subheader-actions d-flex">
            <!-- Languages dropdown -->
            <div v-if="appLanguages" class="languages-dropdown">
                <a
                    class="dropdown-toggle me-1 text-decoration-none"
                    href="#"
                    id="languages-dropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    :aria-label="selectedLanguage.toUpperCase()"
                >

                    <span class="selected-language">{{
                        selectedLanguage.toUpperCase()
                    }}</span>
                    <span
                        class="languages-dropdown-arrow rounded-circle shadow-sm fs-5 mx-2"
                        :class="
                            isCORSite
                                ? 'text-eesc-blue-400'
                                : 'text-eesc-blue-200'
                        "
                    >
                        <font-awesome-icon icon="fas fa-chevron-down"/>
                    </span>
                </a>
                <ul class="dropdown-menu" aria-labelledby="languages-dropdown">
                    <li>
                        <a
                            v-for="lang in appLanguages"
                            :key="lang.code"
                            class="dropdown-item"
                            :href="lang.code"
                            @click.prevent="changeSelectedLanguage(lang.code)"
                            :aria-label="lang.label"
                        >
                            
                            {{ lang.label }}
                        </a>
                    </li>
                </ul>
            </div>
            <a
                :href="contactUrl"
                title="Contact support"
                class="contact-support-btn rounded-circle shadow-sm text-light"
                :class="isCORSite ? 'bg-eesc-blue-400' : 'bg-eesc-blue-200'"
                target="_blank"
                aria-label="Contact support"
            >
                <font-awesome-icon icon="fas fa-comment-alt-dots" class="fs-5"/>
            </a>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Breadcrumbs from './Breadcrumbs.vue';
export default {
    name: 'AppHeader',
    components: {
        Breadcrumbs,
    },
    props: {
        autenthicated: {
            type: Boolean,
            required: false,
        },
        userName: {
            type: String,
            required: false,
        },
    },
    computed: {
        ...mapGetters([
            'appLanguages',
            'selectedLanguage',
            'isCORSite',
            'currentSite',
            'isRegistrationFlow',
            'contactUrl',
            'appLogoUrl',
        ]),
        logoutLink() {
            return `/${this.selectedLanguage}/account/logout`;
        },
        // siteLogoLink() {
        //     if (this.isRegistrationFlow) {
        //         return this.isCORSite
        //             ? `https://cor.europa.eu/${this.selectedLanguage}/about/jobs/Pages/Traineeships.aspx`
        //             : `https://www.eesc.europa.eu/${this.selectedLanguage}/work-with-us/traineeships`;
        //     } else {
        //         return this.isCORSite
        //             ? `https://cor.europa.eu/${this.selectedLanguage}`
        //             : `https://www.eesc.europa.eu/${this.selectedLanguage}`;
        //     }
        // },
        siteLogoImgSrc() {
            return this.isCORSite
                ? require(`@/assets/images/cor-logo.png`)
                : require(`@/assets/images/eesc-logo.svg`);
        },
        // mailToUrl() {
        //     if (this.isRegistrationFlow) {
        //         return this.isCORSite
        //             ? `https://cor.europa.eu/${this.selectedLanguage}/Pages/contact-us.aspx`
        //             : `https://www.eesc.europa.eu/${this.selectedLanguage}/general-contact-form`;
        //     } else {
        //         return this.isCORSite
        //             ? 'mailto:trainee@cor.europa.eu'
        //             : 'mailto:EESC-trainee@eesc.europa.eu';
        //     }
        // },
    },
    methods: {
        ...mapActions(['changeSelectedLanguage', 'clearSession']),
        checkAuthentication() {
            // TODO - this check should be deleted when backend fixes issue;
            if (
                location.pathname.search('logout') > -1 &&
                $('#body .alert.alert-success').length
            ) {
                this.isAuthenticated = false;
            }
        },
    },
    data() {
        return {
            isAuthenticated: this.autenthicated,
        };
    },
    mounted() {
        this.checkAuthentication();
    },
};
</script>
